export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11705.6cc94f03.jpg";